import React from 'react'
import { ColorValue, StyleProp, StyleSheet, TextStyle } from 'react-native'
import { SvgProps } from 'react-native-svg'

import IconAccount from './account'
import IconBuilding from './building'
import IconBuildingAdd from './buildingadd'
import IconBullhorn from './bullhorn'
import IconCalendar from './calendar'
import IconCamera from './camera'
import IconCameraSwitch from './cameraswitch'
import IconCart from './cart'
import IconCheckmark from './checkmark'
import IconCheckmarkLight from './checkmarklight'
import IconClock from './clock'
import IconClose from './close'
import IconDesk from './desk'
import IconDown from './down'
import IconEyeClosed from './eyeclosed'
import IconEyeOpen from './eyeopen'
import IconFinance from './finance'
import IconFirst from './first'
import IconGear from './gear'
import IconGraph from './graph'
import IconGrid from './grid'
import IconHome from './home'
import IconInfo from './info'
import IconLast from './last'
import IconLayers from './layers'
import IconLeft from './left'
import IconList from './list'
import IconLocation from './location'
import IconMap from './map'
import IconMarker from './marker'
import IconMaximize from './maximize'
import IconMeeting from './meeting'
import IconMenu from './menu'
import IconMinus from './minus'
import IconPaperclip from './paperclip'
import IconPencil from './pencil'
import IconPin from './pin'
import IconPlaceholder from './placeholder'
import IconPlus from './plus'
import IconQRCode from './qrcode'
import IconRefresh from './refresh'
import IconRight from './right'
import IconRotate from './rotate'
import IconSearch from './search'
import IconSignal from './signal'
import IconTarget from './target'
import IconTrash from './trash'
import IconUp from './up'
import IconUpload from './upload'
import IconMarkerAdd from './markeradd'
import IconDots from './dots'
import IconCross from './cross'
import IconDownload from './download'
import IconTransfer from './transfer'
import IconSend from './send'
import IconCopy from './copy'

const IconConfig = {
  account: IconAccount,
  building: IconBuilding,
  buildingAdd: IconBuildingAdd,
  bullhorn: IconBullhorn,
  calendar: IconCalendar,
  camera: IconCamera,
  cameraSwitch: IconCameraSwitch,
  cart: IconCart,
  checkmark: IconCheckmark,
  checkmarkLight: IconCheckmarkLight,
  clock: IconClock,
  close: IconClose,
  cross: IconCross,
  desk: IconDesk,
  dots: IconDots,
  down: IconDown,
  download: IconDownload,
  copy: IconCopy,
  eyeClosed: IconEyeClosed,
  eyeOpen: IconEyeOpen,
  finance: IconFinance,
  first: IconFirst,
  gear: IconGear,
  graph: IconGraph,
  grid: IconGrid,
  home: IconHome,
  info: IconInfo,
  last: IconLast,
  layers: IconLayers,
  left: IconLeft,
  list: IconList,
  location: IconLocation,
  map: IconMap,
  marker: IconMarker,
  markerAdd: IconMarkerAdd,
  maximize: IconMaximize,
  meeting: IconMeeting,
  menu: IconMenu,
  minus: IconMinus,
  pencil: IconPencil,
  paperclip: IconPaperclip,
  placeholder: IconPlaceholder,
  plus: IconPlus,
  qrcode: IconQRCode,
  refresh: IconRefresh,
  right: IconRight,
  rotate: IconRotate,
  search: IconSearch,
  signal: IconSignal,
  target: IconTarget,
  transfer: IconTransfer,
  trash: IconTrash,
  send: IconSend,
  up: IconUp,
  upload: IconUpload,
  pin: IconPin,
}

export const Names = Object.keys(IconConfig) as Name[]
export type Name = keyof typeof IconConfig

const SizeConfig = {
  L: 36,
  M: 24,
  S: 14,
  XS: 11,
}

export type Size = keyof typeof SizeConfig
export const Sizes = Object.keys(SizeConfig) as Size[]

export interface Props extends Omit<SvgProps, 'style' | 'color'> {
  name: Name
  size?: Size | number
  color?: ColorValue
  style?: StyleProp<TextStyle>
}
const Icon = (props: Props) => {
  const { name, color, size, style, ...otherProps } = props
  const Icon = IconConfig[name]
  if (!Icon) {
    console.error(`Invalid Icon name ${name}`)
    return null
  }
  const iconColor = (style && StyleSheet.flatten(style).color) || color

  const iconSize = typeof size === 'number' ? size : SizeConfig[size || 'M']

  const width = Math.min(iconSize, (iconSize * Icon.dimensions.width) / Icon.dimensions.height)
  const height = Math.min(iconSize, (iconSize * Icon.dimensions.height) / Icon.dimensions.width)

  return <Icon {...otherProps} style={style} color={iconColor as ColorValue} width={width} height={height} />
}

export default Icon
